﻿$.fn.dxChartPolarRepartClickVue = function custom_dxChartPolarRepartClickVue(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlchartpolarrepartclickvue dx-ctrl");
        this.createInstance(new cdxChartPolarRepartClickVue(this, option));
    }
    return this;
}

window.cdxChartPolarRepartClickVue = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.context_grid == 'undefined') option.context_grid = "datachartpolarrepartclickvue"
    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid] == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid] = {}
    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].polar_repart_vue_click_vue_detaille == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid].polar_repart_vue_click_vue_detaille = false
    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].polar_repart_vue_click_affiche_vue == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid].polar_repart_vue_click_affiche_vue = true
    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].polar_repart_vue_click_affiche_click == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid].polar_repart_vue_click_affiche_click = true
    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].polar_repart_vue_click_type == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid].polar_repart_vue_click_type = "area"

    function mConstruit() {
        container.empty()
        container.css({ "height": "100%", "width": "100%" })
        Me.mUpdate()
    }

    var dxChart = null
    var dxZoom = null
    var oldDs = null
    function mRempli(ds) {
        if (dxChart == null) {
            container.empty()
            if (ds.length == 0) {
                $("<div>(aucune vue/click)</div>").appendTo(container)
            } else {

                var $Table = $("<table style='width:100%'/>").appendTo(container)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:50%;'/>").appendTo($Tr)
                var $Td = $("<td style='width:1px;padding-right:10px;'/>").appendTo($Tr)
                $("<div style='white-space:nowrap;'/>").appendTo($Td).dxCheckBox({
                    text: "Détaillé par jour",
                    value: option.bddCtrl.utiCourantParaJson[option.context_grid].polar_repart_vue_click_vue_detaille,
                    onValueChanged: function (e) {
                        option.bddCtrl.utiCourantParaJson[option.context_grid].polar_repart_vue_click_vue_detaille = e.value
                        option.bddCtrl.mSaveParaJsonUtilisateur();
                        Me.mUpdate()
                    },
                    onContentReady: function (e) { e.element.find(".dx-checkbox-text").css({ "white-space": "nowrap", "font-family": "barlow condensed" }) }
                })
                var $Td = $("<td style='width:1px;padding-right:10px;'/>").appendTo($Tr)
                $("<div style='white-space:nowrap;'/>").appendTo($Td).dxCheckBox({
                    text: "Afficher vues",
                    value: option.bddCtrl.utiCourantParaJson[option.context_grid].polar_repart_vue_click_affiche_vue,
                    onValueChanged: function (e) {
                        option.bddCtrl.utiCourantParaJson[option.context_grid].polar_repart_vue_click_affiche_vue = e.value
                        option.bddCtrl.mSaveParaJsonUtilisateur();
                        Me.mUpdate()
                    },
                    onContentReady: function (e) { e.element.find(".dx-checkbox-text").css({ "white-space": "nowrap", "font-family": "barlow condensed" }) }
                })
                var $Td = $("<td style='width:1px;padding-right:10px;'/>").appendTo($Tr)
                $("<div style='white-space:nowrap;'/>").appendTo($Td).dxCheckBox({
                    text: "Afficher clicks",
                    value: option.bddCtrl.utiCourantParaJson[option.context_grid].polar_repart_vue_click_affiche_click,
                    onValueChanged: function (e) {
                        option.bddCtrl.utiCourantParaJson[option.context_grid].polar_repart_vue_click_affiche_click = e.value
                        option.bddCtrl.mSaveParaJsonUtilisateur();
                        Me.mUpdate()
                    },
                    onContentReady: function (e) { e.element.find(".dx-checkbox-text").css({ "white-space": "nowrap", "font-family": "barlow condensed" }) }
                })
                var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
                $("<div style=''/>").appendTo($Td).dxSwitch({
                    switchedOffText: "Ligne",
                    switchedOnText: "Aire   ",
                    width: 55,
                    value: (option.bddCtrl.utiCourantParaJson[option.context_grid].polar_repart_vue_click_type == "area"),
                    onValueChanged: function (e) {
                        option.bddCtrl.utiCourantParaJson[option.context_grid].polar_repart_vue_click_type = ((e.value) ? "area" : "line")
                        option.bddCtrl.mSaveParaJsonUtilisateur();
                        Me.mUpdate()
                    },
                    onContentReady: function (e) {
                        e.element.find(".dx-switch-on").css({ "font-family": "barlow condensed" })
                        e.element.find(".dx-switch-off").css({ "font-family": "barlow condensed" })
                    }
                })
                var $Td = $("<td style='width:50%;'/>").appendTo($Tr)

                var widthHeight = 0
                var nb = 8
                if (ds.length == 2) {
                    widthHeight = container.innerWidth() / 2
                    nb = 2
                } else {
                    nb=3
                    widthHeight = container.innerWidth() / 3
                    //while (widthHeight >= 190 && nb != 0) {
                    //    nb -= 1
                    //    widthHeight = container.innerWidth() / nb
                    //}
                    //if (nb == 0) nb = 1
                    //widthHeight = container.innerWidth() / nb
                }
                ds.forEach(function (data) {
                    var $Div = $("<div style='width:" + (100 / nb) + "%;display:inline-block;'/>").appendTo(container)
                    $("<div style='text-align:center;font-weight:bold;font-size:130%;font-variant:small-caps;'>" + data.title + "</div>").appendTo($Div)
                    var series = []
                    if (option.bddCtrl.utiCourantParaJson[option.context_grid].polar_repart_vue_click_affiche_vue) series.push({ argumentField: "heure", valueField: 'nb_vue', name: 'Vues', color: "orange" })
                    if (option.bddCtrl.utiCourantParaJson[option.context_grid].polar_repart_vue_click_affiche_click) series.push({ argumentField: "heure", valueField: 'nb_click', name: 'Clicks', color: "red" })
                    $("<div style='width:100%;'/>").appendTo($Div).dxPolarChart({
                        dataSource: data.lst,
                        useSpiderWeb: false,
                        size: {
                            width: widthHeight,
                            height: widthHeight
                        },
                        legend: { visible: false },
                        series: series,
                        //valueAxis: {
                        //    type:"logarithmic"
                        //},
                        commonSeriesSettings: {
                            type: option.bddCtrl.utiCourantParaJson[option.context_grid].polar_repart_vue_click_type,
                        },
                        export: {
                            enabled: false,
                        },
                        tooltip: {
                            enabled: true,
                            container: container,
                            customizeTooltip: function (e) {
                                return {
                                    text: `${e.argumentText}h - ${e.valueText} ${e.seriesName}`,
                                };
                            }
                        },
                    });
                })

                oldDs = ds
            }
        } else {
            if (JSON.stringify(oldDs) != JSON.stringify(ds)) {
                dxChart.option("dataSource", ds)
                dxZoom.option("dataSource", ds)
                oldDs = ds
            }
        }
    }

    this.mUpdate = function () {
        option.bddCtrl.mAjaxCall({ command: "getrepartjournbvueclick", id_table_com: option.idTableCom, id_com: option.idCom }, function (data) {
            if (typeof data.lstvueclickjour == 'undefined') data.lstvueclickjour = []
            var lstResult = []
            if (!option.bddCtrl.utiCourantParaJson[option.context_grid].polar_repart_vue_click_vue_detaille) {
                //on rasssemble les jours de semaines et les week-end
                var lstResultSemaine = []
                for (var i = 0; i <= 23; i++) {
                    lstResultSemaine.push({ heure: i, nb_vue: 0, nb_click: 0 })
                }
                data.lstvueclickjour.filter(function (o) {
                    return o.jour == "lundi" || o.jour == "mardi" || o.jour == "mercredi" || o.jour == "jeudi" || o.jour == "vendredi"
                }).forEach(function (o) {
                    var semaine = lstResultSemaine.filter(function (o2) { return o2.heure == o.heure })[0]
                    semaine.nb_vue += o.nb_vue
                    semaine.nb_click += o.nb_click
                })
                lstResult.push({ title: "Semaine", lst: lstResultSemaine })
                var lstResultWe = []
                for (var i = 0; i <= 23; i++) {
                    lstResultWe.push({ heure: i, nb_vue: 0, nb_click: 0 })
                }
                data.lstvueclickjour.filter(function (o) {
                    return o.jour == "samedi" || o.jour == "dimanche"
                }).forEach(function (o) {
                    var we = lstResultWe.filter(function (o2) { return o2.heure == o.heure })[0]
                    we.nb_vue += o.nb_vue
                    we.nb_click += o.nb_click
                })
                lstResult.push({ title: "Week-end", lst: lstResultWe })
            } else {
                var lstResultLu = []
                for (var i = 0; i <= 23; i++) {
                    lstResultLu.push({ heure: i, nb_vue: 0, nb_click: 0 })
                }
                data.lstvueclickjour.filter(function (o) {
                    return o.jour == "lundi"
                }).forEach(function (o) {
                    var jour = lstResultLu.filter(function (o2) { return o2.heure == o.heure })[0]
                    jour.nb_vue += o.nb_vue
                    jour.nb_click += o.nb_click
                })
                lstResult.push({ title: "Lundi", lst: lstResultLu })

                var lstResultMa = []
                for (var i = 0; i <= 23; i++) {
                    lstResultMa.push({ heure: i, nb_vue: 0, nb_click: 0 })
                }
                data.lstvueclickjour.filter(function (o) {
                    return o.jour == "mardi"
                }).forEach(function (o) {
                    var jour = lstResultMa.filter(function (o2) { return o2.heure == o.heure })[0]
                    jour.nb_vue += o.nb_vue
                    jour.nb_click += o.nb_click
                })
                lstResult.push({ title: "Mardi", lst: lstResultMa })

                var lstResultMe = []
                for (var i = 0; i <= 23; i++) {
                    lstResultMe.push({ heure: i, nb_vue: 0, nb_click: 0 })
                }
                data.lstvueclickjour.filter(function (o) {
                    return o.jour == "mercredi"
                }).forEach(function (o) {
                    var jour = lstResultMe.filter(function (o2) { return o2.heure == o.heure })[0]
                    jour.nb_vue += o.nb_vue
                    jour.nb_click += o.nb_click
                })
                lstResult.push({ title: "Mercredi", lst: lstResultMe })

                var lstResultJe = []
                for (var i = 0; i <= 23; i++) {
                    lstResultJe.push({ heure: i, nb_vue: 0, nb_click: 0 })
                }
                data.lstvueclickjour.filter(function (o) {
                    return o.jour == "jeudi"
                }).forEach(function (o) {
                    var jour = lstResultJe.filter(function (o2) { return o2.heure == o.heure })[0]
                    jour.nb_vue += o.nb_vue
                    jour.nb_click += o.nb_click
                })
                lstResult.push({ title: "Jeudi", lst: lstResultJe })

                var lstResultVe = []
                for (var i = 0; i <= 23; i++) {
                    lstResultVe.push({ heure: i, nb_vue: 0, nb_click: 0 })
                }
                data.lstvueclickjour.filter(function (o) {
                    return o.jour == "vendredi"
                }).forEach(function (o) {
                    var jour = lstResultVe.filter(function (o2) { return o2.heure == o.heure })[0]
                    jour.nb_vue += o.nb_vue
                    jour.nb_click += o.nb_click
                })
                lstResult.push({ title: "Vendredi", lst: lstResultVe })

                var lstResultSa = []
                for (var i = 0; i <= 23; i++) {
                    lstResultSa.push({ heure: i, nb_vue: 0, nb_click: 0 })
                }
                data.lstvueclickjour.filter(function (o) {
                    return o.jour == "samedi"
                }).forEach(function (o) {
                    var jour = lstResultSa.filter(function (o2) { return o2.heure == o.heure })[0]
                    jour.nb_vue += o.nb_vue
                    jour.nb_click += o.nb_click
                })
                lstResult.push({ title: "Samedi", lst: lstResultSa })

                var lstResultDi = []
                for (var i = 0; i <= 23; i++) {
                    lstResultDi.push({ heure: i, nb_vue: 0, nb_click: 0 })
                }
                data.lstvueclickjour.filter(function (o) {
                    return o.jour == "dimanche"
                }).forEach(function (o) {
                    var jour = lstResultDi.filter(function (o2) { return o2.heure == o.heure })[0]
                    jour.nb_vue += o.nb_vue
                    jour.nb_click += o.nb_click
                })
                lstResult.push({ title: "Dimanche", lst: lstResultDi })
            }
            mRempli(lstResult)
        })
    }

    this.element = function () { return container }
    this.focus = function () { }

    mConstruit();
}